// extracted by mini-css-extract-plugin
export default {"tabList":"AddProductForm_tabList__AsHj2 react-tabs__tab-list","title":"AddProductForm_title__jtB4-"};